import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import styled from "styled-components";

export default makeStyles((theme) => ({
  spinner: {
    marginLeft: 15,
    position: "relative",
    top: 4,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main, 
    fontSize: '1rem'
  },
  brandLogoBar: {
    background: theme.palette.background.paper,
    padding: '10px 10px 0px 10px',
  },
  brandLogoTitle: {
    fontWeight: 'normal',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '1.5rem'
  },
  listDataTable: {
    // padding: 0
  },
  fontSizeCstm: {
    fontSize: "0.875rem",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.overlayBg.background,
  },
  statusBg: {
    borderRadius: '2px',
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '1px',
    paddingRight: '12px',
    paddingLeft: '12px'
  },
}));


export const getMuiTheme = (selectedTheme) => {
  return createMuiTheme({
    ...selectedTheme,
    overrides: {
      MuiPaper: {
        root: {
          boxShadow: 'none !important'
        }
      },
      MuiToolbar: {
        root: {
          padding: "0px",
          fontFamily: "Source Sans Pro"
        },
        gutters: {
          paddingRight: "0px !important",
        },
      },
      MUIDataTableToolbar: {
        paddingLeft: '10px',
      },
      MUIDataTableToolbarSelect: {

        title: {
          display: 'none',
          paddingLeft: '10px'
        }
      },

      MuiTableCell: {
        root: {
          fontFamily: "Source Sans Pro"
        }
      },
      MUIDataTableBodyCell: {
        root: {
          padding: "4px",
          // eslint-disable-next-line no-useless-computed-key
          ["@media (min-width:959.5px)"]: {
            padding: "0px 4px",
          },
        },
      },
      MUIDataTableHeadCell: {
        root: {
          padding: "0px 8px",

        },
      },
      PrivateSwitchBase: {
        root: {
          padding: "4px 0px 4px 4px"
        }
      },
      MuiIconButton: {
        root: {
          padding: "6px"
        }
      },
      MuiPaper: {
        elevation4: {
          boxShadow: "none"
        }
      },
      MuiTableSortLabel: {
        root: {
          marginTop: 5
        }
      },
      MUIDataTablePagination:{
        tableCellContainer:{
          padding:"0px",
        },
      },
    },
  })
}
